import { memo } from 'react';

import Container from '@ui/container/container';
import useComputedRegistrationSettings from '../../../hooks/use-computed-registration-settings';
import { SignInOptionsList } from './sign-in-option-types';
import RenderSignInOption from './render-signin-option';
import Text from '@ui/text/text/text';
import TooltipPortal from '@ui/tooltip-portal/tooltip-portal';
import { ICONS } from '@ui/icons/types';
import IconWithBackdrop from '@ui/icons/icon-with-backdrop';

const SignInOptions = memo(() => {
  const { registrationSettings } = useComputedRegistrationSettings();

  return (
    <div className="flex fd-column gap-8">
      <Container className="flex ai-center gap-6">
        <Text tag="h5" className="H5" design="GlobalIcoText1">
          Social sign in
        </Text>
        <TooltipPortal
          styles={{ backgroundColor: 'var(--global-cont-2)' }}
          tooltipContent={<Text design="GlobalIcoText1">Allow users to sign in with google account</Text>}
        >
          <IconWithBackdrop
            name={ICONS.INFO_CIRCLE}
            size={12}
            color="var(--primitives-mode-1-gray-500)"
            backdropColor="var(--primitives-mode-1-gray-100)"
          />
        </TooltipPortal>
      </Container>
      <Container design="GlobalCont1" className="flex fd-column padding-v-10 padding-h-16" borderRadius="12px">
        <Container className="flex fd-column gap-8">
          {SignInOptionsList.map((option) => (
            <RenderSignInOption
              key={option.uuid || option?.label}
              option={option}
              registrationSettings={registrationSettings}
            />
          ))}
        </Container>
      </Container>
    </div>
  );
});

SignInOptions.displayName = 'SignInOptions';

export default SignInOptions;
